import { useCallback, useEffect, useState } from "react";

const usePwa = () => {

  const [installPrompt, setInstallPrompt] = useState(null);
  const [pwaDismissed, setPwaDismissed] = useState(false);
  const [iosPwa, setIosPwa] = useState(false);
  const [iosPwaModalActive, setIosPwaModalActive] = useState(false);

  const [showPwaBanner, setShowPwaBanner] = useState(false);

  const dismissPwa = useCallback(() => {
    setPwaDismissed(true);
  }, []);

  const pwaInstallClicked = useCallback(() => {
    if (!iosPwa) {
      // hide our user interface that shows our install button
      setPwaDismissed(true);
      // Show the prompt
      if (installPrompt) {
        installPrompt.prompt();

        // Wait for the user to respond to the prompt
        installPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the install prompt');
          } else {
            console.log('User dismissed the install prompt');
          }
          setInstallPrompt(cur => {
            return null;
          });
        });
      }
    }
    else {
      setIosPwaModalActive(true);
    }
  }, [installPrompt, iosPwa]);

  const closeIosModal = useCallback(() => {
    setIosPwaModalActive(false);
  }, []);

  useEffect(() => {
    const isIos = () => {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }
    // Detects if device is in standalone mode
    const isInStandaloneMode = () =>
      ('standalone' in window.navigator) && (window.navigator.standalone);

    // Checks if should display install popup notification:
    if (isIos() && !isInStandaloneMode()) {
      //ios
      setShowPwaBanner(true);
      setIosPwa(true);
    }

    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      setInstallPrompt(e);
      // Update UI to notify the user they can add to home screen
      //android
      setShowPwaBanner(true);
    });
  }, []);

  return {
    showPwaBanner,
    pwaDismissed,
    pwaInstallClicked,
    dismissPwa,
    closeIosModal,
    iosPwaModalActive
  }
}

export default usePwa;